module.exports = __webpack_public_path__ + "img/1left-n-a953a448.png";